import React, { useCallback } from "react";
import { ModalProps, Stack } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./SignOutModal.scss";
import GhostButton from "../../dashboard-page/GhostButton/GhostButton";
import useAuth from "../../../hooks/useAuth";
import { ROUTES } from "../../../utils/constants";
import BottomDrawer from "../../BottomDrawer/BottomDrawer";
import PrimaryActionButton from "../../Buttons/PrimaryActionButton/PrimaryActionButton";

interface SignOutModalProps extends Pick<ModalProps, "show"> {
  redirectUrl?: string;
  onHide: () => void;
}
function SignOutModal({
  show,
  onHide,
  redirectUrl = ROUTES.GAMES.ROOT,
  ...restProps
}: SignOutModalProps) {
  const navigate = useNavigate();
  const { logOut } = useAuth();
  const { t } = useTranslation("common");

  const handleSignOut = useCallback(() => {
    logOut();
    navigate(redirectUrl);
  }, [logOut, navigate, redirectUrl]);

  return (
    <BottomDrawer onClose={onHide} isOpen={!!show} {...restProps}>
      <Stack gap={4} className="sign-out-modal">
        <Stack className="content">
          <h2 className="main-copy">{t("profile.sign_out")}</h2>
          <p className="sub-copy">
            {t("profile.are_you_sure_you_want_to_sign_out")}
          </p>
        </Stack>
        <Stack className="cta-container">
          <PrimaryActionButton
            text={t("no_go_back")}
            onClick={onHide}
            buttonClassName="text-capitalize"
          />
          <GhostButton className="cancel-btn" onClick={handleSignOut}>
            {t("profile.sign_out")}
          </GhostButton>
        </Stack>
      </Stack>
    </BottomDrawer>
  );
}

export default SignOutModal;
